'use client'
// Auto-generated by boneyard vite plugin — do not edit
import { registerBones } from 'boneyard-js/react'

import _clients_admin_filters from './clients-admin-filters.bones.json'
import _clients_table from './clients-table.bones.json'
import _inventory_kpi_current_status from './inventory-kpi-current-status.bones.json'
import _inventory_kpi_monthly_activity from './inventory-kpi-monthly-activity.bones.json'
import _inventory_kpi_sold_by_project from './inventory-kpi-sold-by-project.bones.json'
import _inventory_project_filters from './inventory-project-filters.bones.json'
import _inventory_table from './inventory-table.bones.json'
import _inventory_type_property_filters from './inventory-type-property-filters.bones.json'

registerBones({
  'clients-admin-filters': _clients_admin_filters,
  'clients-table': _clients_table,
  'inventory-kpi-current-status': _inventory_kpi_current_status,
  'inventory-kpi-monthly-activity': _inventory_kpi_monthly_activity,
  'inventory-kpi-sold-by-project': _inventory_kpi_sold_by_project,
  'inventory-project-filters': _inventory_project_filters,
  'inventory-table': _inventory_table,
  'inventory-type-property-filters': _inventory_type_property_filters
})
